var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVenus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M368 176C368 78.799 289.203 0 192 0C94.799 0 16 78.799 16 176C16 265.039 82.182 338.443 168 350.176V392H120C106.75 392 96 402.75 96 416S106.75 440 120 440H168V488C168 501.25 178.75 512 192 512S216 501.25 216 488V440H264C277.25 440 288 429.25 288 416S277.25 392 264 392H216V350.176C301.818 338.445 368 265.039 368 176ZM64 176C64 105.42 121.422 48 192 48C262.58 48 320 105.42 320 176S262.58 304 192 304C121.422 304 64 246.58 64 176Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenus);
export default __webpack_public_path__ + "static/media/venus.61a66e68e0f5156d6a742021b7162aab.svg";
export { ForwardRef as ReactComponent };